import { useCallback, useEffect, useState } from 'react'

const TOAST_MS = 5000

/** Fixed bottom toast (.snav) — monochrome ink tokens only. */
export function useActionToast() {
  const [toast, setToast] = useState<string | null>(null)

  useEffect(() => {
    if (!toast) return
    const timer = window.setTimeout(() => setToast(null), TOAST_MS)
    return () => window.clearTimeout(timer)
  }, [toast])

  const showToast = useCallback((message: string) => {
    setToast(message)
  }, [])

  const Toast = toast ? (
    <div className="snav" role="status" data-testid="action-toast">
      {toast}
    </div>
  ) : null

  return { showToast, Toast }
}
